import { ContentHubData } from "@app/types/ServerCustomContext";
import { configHome } from "@pub/config";
import placeholders from "@pub/placeholders";
import { Card, Typography } from "@sphtech/dmg-design-system";

import styles from "./contentlistsectag.module.css";

const { Heading } = Typography;

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

const ContentListSecTag = ({ data }: Props) => {
  if (
    !data?.contentHubList?.teasers ||
    data.contentHubList.teasers.length === 0
  ) {
    return null;
  }

  const contentListData = data.contentHubList;

  return (
    <div className={styles.backgroundContainer}>
      <div className={styles.headingTitle}>
        <Heading.SubSectionTitle
          nameZH={contentListData.titleZH}
          headingUrl={contentListData.titleUrl}
        >
          {contentListData.title}
        </Heading.SubSectionTitle>
        {contentListData.titleUrl && configHome.viewMore?.icon}
      </div>

      <div className={styles.contentContainer}>
        {contentListData.teasers.map((teaser, index) => {
          return (
            <div key={index} className={styles.itemContainer}>
              <Card
                {...teaser}
                variant="card-stacked-original"
                mobileUpVariant="card-stacked-original-mobile-up"
                placeholders={placeholders}
                displayPublishDate={false}
                tags={undefined}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContentListSecTag;
